import createReactComponent from '../createReactComponent';
export default createReactComponent('grip-horizontal', 'GripHorizontal', [["path",{"d":"M12 15v-.667M17 15v-.667M7 15v-.667m5-4.666V9m5 .667V9M7 9.667V9","key":"svg-0"}]]);